import { FlosIcon } from '@flos/react-ui';
import { type CoverageTextItem } from '../../../../recoil/types/hippoTypes';

export default function CoverageContentComponent(props: {
    coverageContent?: CoverageTextItem;
}): React.JSX.Element {
    const { coverageContent } = props;
    const hasIncludedCoverageContent =
        coverageContent?.included && coverageContent.included.items.length > 0;
    const hasExcludedCoverageContent =
        coverageContent?.excluded && coverageContent.excluded.items.length > 0;

    if (!coverageContent) return <></>;
    return (
        <>
            {hasIncludedCoverageContent && (
                <ul className="List List--icons" id="included-coverage-list">
                    {coverageContent?.included?.items.map((item) => (
                        <li
                            key={item}
                            id="included-coverage-item"
                            data-testid="includedCoverageList"
                        >
                            <FlosIcon shape="check" size="medium" className="has-fill is-green" />
                            {item}
                        </li>
                    ))}
                </ul>
            )}
            {hasExcludedCoverageContent && (
                <ul className="List List--icons" id="excluded-coverage-list">
                    {coverageContent?.excluded?.items.map((item) => (
                        <li
                            key={item}
                            id="excluded-coverage-item"
                            data-testid="excludedCoverageList"
                        >
                            <FlosIcon
                                shape="circle-x"
                                size="medium"
                                className="has-fill is-secondary-4"
                            />
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
}
